import { Box, Divider } from "@mui/material";
import { NumericFormat } from "react-number-format";
import { Text } from "./CustomInputs";

type Props = {
  value: string | number;
  defaultValue?: string | number;
  unit: string;
};

const TotalSalary = ({ value, unit, defaultValue }: Props) => {
  return (
    <Box display="flex" flexDirection="column">
      <Divider
        sx={{
          backgroundColor: "#000",
          marginBottom: "3px",
        }}
      />
      <NumericFormat
        value={value}
        defaultValue={defaultValue}
        decimalSeparator=","
        valueIsNumericString
        maxWidth="135px"
        customInput={Text}
        decimalScale={2}
        unit={unit}
      />
    </Box>
  );
};

export default TotalSalary;
